module.exports = "<div class=c-edit-reservation ng-if=$ctrl.isEditing()> <button class=\"c-loginout__action / t-text--secondary--action\" ng-click=$ctrl.stopEditing()>Logout</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/stopEditing.html
// module id = 792
// module chunks = 0